import { Nilable } from "../shared/utils/Nullable";


export interface IRespuestasGptDTO {
    answers: Nilable<IRespuestaGptDTO[]>;
}

export class RespuestasGptDTO {
    respuestas: Nilable<RespuestaGptDTO[]> = null;

    constructor(json: Nilable<Partial<IRespuestasGptDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IRespuestasGptDTO>) {
        if (json.answers != null) {
            this.respuestas = json.answers.map(answer => new RespuestaGptDTO(answer));
        }
    }

    public toJSON(): IRespuestasGptDTO {
        return {
            answers: this.respuestas?.map(respuesta => respuesta.toJSON()) ?? null
        };
    }
}

export interface IRespuestaGptDTO {
    original_text: string;
    replaced_text: Nilable<string>;
    question_topic: Nilable<string>;
    topic_category: Nilable<string>;
    country: Nilable<string>;
    banneable: boolean;
    warning: boolean;
    discard: boolean;
}

export class RespuestaGptDTO {

    respuestaOriginal = "";
    respuestaGpt = "";
    categoriaPregunta = "";
    industriaCategoriaPregunta = "";
    pais = "";
    banneable = false;
    warning = false;
    discard = false;

    constructor(json: Nilable<Partial<IRespuestaGptDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IRespuestaGptDTO>) {
        if (json.original_text != null ) {
            this.respuestaOriginal = json.original_text;
        }
        if (json.replaced_text != null) {
            this.respuestaGpt = json.replaced_text;
        }
        if (json.question_topic != null) {
            this.categoriaPregunta = json.question_topic;
        }
        if (json.topic_category != null) {
            this.industriaCategoriaPregunta = json.topic_category;
        }
        if (json.country != null) {
            this.pais = json.country;
        }
        if (json.banneable != null) {
            this.banneable = json.banneable;
        }
        if (json.warning != null) {
            this.warning = json.warning;
        }
        if (json.discard != null) {
            this.discard = json.discard;
        }
    }

    public toJSON(): IRespuestaGptDTO {
        return {
            original_text: this.respuestaOriginal,
            replaced_text: this.respuestaGpt,
            question_topic: this.categoriaPregunta,
            topic_category: this.industriaCategoriaPregunta,
            country: this.pais,
            banneable: this.banneable,
            warning: this.warning,
            discard: this.discard
        };
    }
}
